import { call, put, takeLatest, select } from 'redux-saga/effects';
import request from '../../../utils/request';
import { actions } from './slice';
import { BACKEND_URL } from '../../../variables';
const { 
    searchOtherKindCodes,
    searchOtherKindCodesSuccess,
    searchOtherKindCodesError
} = actions;

// Selector to get the previous data
const selectPreviousData = (state) => state.otherKindCodes.data;

export function searchRequest(api = request) {
    return function* (action) {
        const requestURL = `${BACKEND_URL}/publications?page=${action.payload.page || 0}&size=10`;
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(action.payload),
        };

        // Get the previous data
        const previousData = yield select(selectPreviousData);

        // Check if the previous data was empty
        if (!previousData || previousData.content.length !== 0) {
            try {
                const data: object[] = yield call(api, requestURL, options);
                yield put(searchOtherKindCodesSuccess(data));
            } catch (error: any) {
                yield put(searchOtherKindCodesError(error.response));
            }
        }
    };
}
export default function* rootSaga() {
    yield takeLatest(searchOtherKindCodes.type, searchRequest());
}